<template>
  <div class="content_">

    <!-- Drawing History Modal -->
    <modal name="drawing-history-modal" :adaptive="true" :minHeight="400" height="auto" :minWidth="600" width="80%" :scrollable="true">
      <drawing-history-modal 
        v-if="selectedDrawCategory"
        :categoryId="selectedDrawCategory.id"
        @close="$modal.hide('drawing-history-modal')"
        @view-version="handleViewVersion"
        @restore-version="handleRestoreVersion"
      />
    </modal>

    <div class="container-fluid_">
      <div class="row">
        <div class="col-md-12">
<!--          <button class="btn btn-sm btn-fill " v-bind:class="{'btn-warning':showBracket2, 'btn-dark':!showBracket2, }" style="margin: 5px;"  >Сітка 0-2</button>-->
<!--          <button class="btn btn-sm btn-fill " v-bind:class="{'btn-warning':showBracket4, 'btn-dark':!showBracket4, }" style="margin: 5px;"  >Сітка 2-4</button>-->
<!--          <button class="btn btn-sm btn-fill " v-bind:class="{'btn-warning':showBracket8, 'btn-dark':!showBracket8, }" style="margin: 5px;"  >Сітка 4-8</button>-->
<!--          <button class="btn btn-sm btn-fill " v-bind:class="{'btn-warning':showBracket16, 'btn-dark':!showBracket16, }" style="margin: 5px;"  >Сітка 8-16</button>-->
<!--          <button class="btn btn-sm btn-fill " v-bind:class="{'btn-warning':showBracket32, 'btn-dark':!showBracket32, }" style="margin: 5px;"  >Сітка 16-32</button>-->
<!--          <button class="btn btn-sm  btn-fill btn-danger" style="margin: 5px;" @click="getImage">Скачати</button>-->
<!--          <a class="btn btn-sm  btn-fill btn-warning" style="margin: 5px;" :href="baseUrlServer+'/tournament/print-pdf?category='+selectedDrawCategory.id" target="_blank" >Друк жеребування(PDF)</a>-->
<!--          <a class="btn btn-sm  btn-fill btn-warning" style="margin: 5px;" :href="baseUrlServer+'/tournament-result/print-pdf?category='+selectedDrawCategory.id" target="_blank" >Друк результатів (PDF)</a>-->

<!--          <a class="btn btn-sm  btn-fill btn-warning" style="margin: 5px;" :href="baseUrlServer+'/tournament-result-new/print-pdf?category='+selectedDrawCategory.id" target="_blank" >Друк результатів PDF New</a>-->
        </div>
        <div class="col-md-12">
          <!-- Панель дій сітки: жеребкування | історія, друк | рестарт окремо -->
          <div class="bracket-toolbar">
            <div class="bracket-toolbar-group">
              <button type="button" class="adm-btn adm-btn-sm"
                      :class="{'is-on': sortableSheme}"
                      @click="toogleSortableSheme()"
                      :aria-pressed="sortableSheme ? 'true' : 'false'"
                      :title="sortableSheme ? 'Режим ручного жеребкування активний - перетягуйте спортсменів в сітку' : 'Увімкнути ручне жеребкування для перетягування спортсменів'">
                <span aria-hidden="true"><tkd-icon name="hand"/></span>
                Ручне жеребкування
                <span v-if="sortableSheme" class="adm-badge">АКТИВНО</span>
              </button>

<!--          <button class="btn btn-sm btn-fill btn-primary" style="margin: 5px;"
                  v-bind:class="{'btn-dark':!sortableSheme,'btn-primary':sortableSheme, }" @click="toogleAutoSortableSheme(1)">
            Автоматичне жеребкування (Рандомна система)
          </button>-->
              <button type="button" class="adm-btn adm-btn-sm adm-btn-primary" @click="toogleAutoSortableSheme(2)">
                <span aria-hidden="true"><tkd-icon name="dice"/></span>
                Автоматичне жеребкування протокола
              </button>
            </div>

            <div class="bracket-toolbar-group">
              <button type="button" class="adm-btn adm-btn-sm"
                      @click="$modal.show('drawing-history-modal')"
                      :disabled="!$store.getters['tournament/hasDrawingHistory'](selectedDrawCategory.id)"
                      title="Переглянути історію змін жеребкування">
                <span aria-hidden="true"><tkd-icon name="history"/></span>
                Історія змін
                <span v-if="$store.getters['tournament/hasDrawingHistory'](selectedDrawCategory.id)" class="adm-badge">
                  {{ $store.getters['tournament/getDrawingHistory'](selectedDrawCategory.id).length }}
                </span>
              </button>

              <a class="adm-btn adm-btn-sm" :href="baseUrlServer+'/tournament-result/print-pdf?category='+selectedDrawCategory.id" target="_blank" rel="noopener">
                <span aria-hidden="true"><tkd-icon name="print"/></span>
                Друк результатів (PDF)
              </a>
            </div>

            <div class="bracket-toolbar-group bracket-toolbar-end">
              <button type="button" class="adm-btn adm-btn-sm adm-btn-danger" @click="clearBracket()" title="Очистити сітку цієї категорії">
                <span aria-hidden="true"><tkd-icon name="reset"/></span>
                Рестарт сітки
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- Результат поєдинку: відкривається кліком по номеру поєдинку або по спортсмену -->
    <modal name="event-update-form-modal" classes="v--modal adm-modal" @before-close="resetBracketFightForm" :adaptive=true :minHeight=200 height="auto" :minWidth=320 width="92%" :maxWidth=680 :scrollable=true>
      <div class="adm-form fight-form" v-if="selectedFight.technicalNumber.length > 0 || selectedFight.technicalNumber > 0">
        <div class="adm-form-head">
          <div>
            <span class="adm-form-kicker"><tkd-icon name="kyorugi"/> Поєдинок{{ selectedFight.number ? ' №' + selectedFight.number : '' }}</span>
            <h4 class="adm-form-title">{{ selectedDrawCategory.fullname }}</h4>
          </div>
          <button type="button" class="adm-form-close" @click="$modal.hide('event-update-form-modal')" title="Закрити" aria-label="Закрити"><tkd-icon name="close"/></button>
        </div>

        <div class="adm-form-body">
          <section class="adm-section">
            <div class="adm-field fight-number-field">
              <label class="adm-label" for="selectedFightnumber">Номер поєдинку</label>
              <input id="selectedFightnumber" type="text" class="adm-input" autofocus v-model="selectedFight.number" @change="selectedFightChanged()">
            </div>

            <!-- бали: будь-які числа; клік по спортсмену в сітці додає +1 (див. changeRounds) -->
            <div class="fight-row is-blue" v-if="selectedFight.blue.spName.length > 1">
              <span class="corner-tag">Синій</span>
              <label class="fight-row-name" for="sportsman1">{{ selectedFight.blue.spName }}</label>
              <input id="sportsman1" type="text" inputmode="numeric" class="adm-input fight-points-input" v-model="selectedFight.blue.points" @change="pointsChanged()" placeholder="0">
            </div>
            <div class="fight-row is-red" v-if="selectedFight.red.spName.length > 0">
              <span class="corner-tag">Червоний</span>
              <label class="fight-row-name" for="sportsman2">{{ selectedFight.red.spName }}</label>
              <input id="sportsman2" type="text" inputmode="numeric" class="adm-input fight-points-input" v-model="selectedFight.red.points" @change="pointsChanged()" placeholder="0">
            </div>
          </section>

          <section class="adm-section">
            <div class="adm-field">
              <label class="adm-label" for="winner">Переможець</label>
              <select v-model="selectedFight.winSpId" id="winner" class="adm-input" @keyup="selectedFightChanged()" @keydown="selectedFightChanged()" @change="selectedFightChanged()">
                <option value="">-</option>
                <option v-if="selectedFight.blue.spId > 0" :data-val="selectedFight.blue.spId" :value="selectedFight.blue.spId">{{selectedFight.blue.spName}}</option>
                <option v-if="selectedFight.red.spId > 0" :data-val="selectedFight.red.spId" :value="selectedFight.red.spId">{{selectedFight.red.spName}}</option>
              </select>
            </div>

            <div class="adm-field">
              <label class="adm-label" for="decision">Перемога</label>
              <select v-model="selectedFight.decision" id="decision" class="adm-input" @change="selectedFightChanged()">
            <option  value="PTG" selected>по різниці балів (PTG)</option>
            <option value="DSQ">внаслідок дискваліфікації (DSQ)</option>
            <option value="WDP">неявка (WDP)</option>
            <option value="RSC">внаслідок зупинки поєдинка рефері (RSC)</option>
            <option value="PTF">по фінальному рахунку (PTF)</option>
            <option value="GDP">в додатковому (золотому раунді) (GDP)</option>
            <option value="SUP">по перевазі (SUP)</option>
            <option value="WDR">внаслідок зняття спортсмена (WDR)</option>
            <option value="PUN">внаслідок оголошення рефері мір покарання (PUN)</option>
            <option value="KO">перемога нокаутом (KO)</option>
            <option value="IRM">перемога внаслідок запиту тренера на відеоповтор (IRM)</option>
            <option value="DQB">перемога внаслідок дискваліфікації за неспортивну поведінку (DQB)</option>
            <option value="INJ">перемога через травму суперника (INJ)</option>
            <option value="WDP">перемога через неявку суперника (WDP)</option>
            <option value="JUD">перемога за рішенням суддів (JUD)</option>
            <option value="SD">перемога в раунді раптової смерті (SD)</option>
            <option value="TKO">перемога технічним нокаутом (TKO)</option>
            <option value="">інша причина</option>
              </select>
            </div>
          </section>
        </div>

        <div class="adm-form-foot">
          <div class="adm-form-foot-actions">
            <button type="button" class="adm-btn" @click="$modal.hide('event-update-form-modal')">Скасувати</button>
            <button type="button" class="adm-btn adm-btn-primary" @click="saveData"><tkd-icon name="save"/> Зберегти</button>
          </div>
        </div>
      </div>
    </modal>
    <div class="container-fluid_">
      <div class="row_">
        <!-- Ручне жеребкування: підказка + стан автозбереження -->
        <div class="manual-banner" v-if="sortableSheme" role="status">
          <span class="manual-banner-icon" aria-hidden="true"><tkd-icon name="hand"/></span>
          <div class="manual-banner-text">
            <b>Режим ручного жеребкування активний</b>
            <span>Перетягніть спортсмена зі списку «Не в сітці» на місце в першому колі або поміняйте двох спортсменів у сітці місцями.</span>
          </div>
          <span class="save-state" :class="'is-' + bracketSave.state">
            <template v-if="bracketSave.state === 'saving'"><span class="save-spinner"></span>Збереження…</template>
            <template v-else-if="bracketSave.state === 'saved'"><tkd-icon name="check"/> Збережено о {{ bracketSave.time }}</template>
            <template v-else-if="bracketSave.state === 'error'"><tkd-icon name="warning"/> Не збережено — повторіть перетягування</template>
            <template v-else>Зміни зберігаються автоматично</template>
          </span>
        </div>
      </div>
      <div class="row_">
        <div class="col-md-12_ "  >
        <div  id="bracket-image-block" style="/*width: 800px;*/ " class="print-mode">
          <bracket-2 :key="selectedDrawCategory.id + 'bracket' + bracketGen" v-if="showBracket2"
                     :title.sync="selectedDrawCategory.fullname"
                     :sex.sync="selectedDrawCategory.sex"
                     :colorSheme.sync="colorSheme"
                     :drawdata.sync="selectedDrawCategory.drawdata"
                     :categoryid.sync="selectedDrawCategory.id"
                     :tournamentid.sync="selectedDrawCategory.tournament_id"
                     :sortableSheme.sync="sortableSheme"
                     :selectBracketFight.sync="selectBracketFight"
                     :destroy.sync="destroy"

                     ></bracket-2>


          <bracket-4 :key="selectedDrawCategory.id + 'bracket' + bracketGen" v-if="showBracket4"
                     :title.sync="selectedDrawCategory.fullname"
                     :sex.sync="selectedDrawCategory.sex"
                     :colorSheme.sync="colorSheme"
                     :drawdata.sync="selectedDrawCategory.drawdata"
                     :categoryid.sync="selectedDrawCategory.id"
                     :tournamentid.sync="selectedDrawCategory.tournament_id"
                     :sortableSheme.sync="sortableSheme"
                     :selectBracketFight.sync="selectBracketFight"
                     :destroy.sync="destroy"

                     ></bracket-4>

          <bracket-8 :key="selectedDrawCategory.id + 'bracket' + bracketGen" v-if="showBracket8"
                     :title.sync="selectedDrawCategory.fullname"
                     :sex.sync="selectedDrawCategory.sex"
                     :colorSheme.sync="colorSheme"
                     :drawdata.sync="selectedDrawCategory.drawdata"
                     :categoryid.sync="selectedDrawCategory.id"
                     :tournamentid.sync="selectedDrawCategory.tournament_id"
                     :sortableSheme.sync="sortableSheme"
                     :selectBracketFight.sync="selectBracketFight"
                     :destroy.sync="destroy"

                     ></bracket-8>

          <bracket-16 :key="selectedDrawCategory.id + 'bracket' + bracketGen" v-if="showBracket16"
                     :title.sync="selectedDrawCategory.fullname"
                      :sex.sync="selectedDrawCategory.sex"
                     :colorSheme.sync="colorSheme"
                     :drawdata.sync="selectedDrawCategory.drawdata"
                     :categoryid.sync="selectedDrawCategory.id"
                     :tournamentid.sync="selectedDrawCategory.tournament_id"
                     :sortableSheme.sync="sortableSheme"
                     :selectBracketFight.sync="selectBracketFight"
                     :destroy.sync="destroy"

                     ></bracket-16>

          <bracket-32 :key="selectedDrawCategory.id + 'bracket' + bracketGen" v-if="showBracket32"
                     :title.sync="selectedDrawCategory.fullname"
                      :sex.sync="selectedDrawCategory.sex"
                     :colorSheme.sync="colorSheme"
                     :drawdata.sync="selectedDrawCategory.drawdata"
                     :categoryid.sync="selectedDrawCategory.id"
                     :tournamentid.sync="selectedDrawCategory.tournament_id"
                     :sortableSheme.sync="sortableSheme"
                     :selectBracketFight.sync="selectBracketFight"
                     :destroy.sync="destroy"

                     ></bracket-32>
          <bracket-64 :key="selectedDrawCategory.id + 'bracket' + bracketGen" v-if="showBracket64"
                     :title.sync="selectedDrawCategory.fullname"
                      :sex.sync="selectedDrawCategory.sex"
                     :colorSheme.sync="colorSheme"
                     :drawdata.sync="selectedDrawCategory.drawdata"
                     :categoryid.sync="selectedDrawCategory.id"
                     :tournamentid.sync="selectedDrawCategory.tournament_id"
                     :sortableSheme.sync="sortableSheme"
                     :selectBracketFight.sync="selectBracketFight"
                      :zoomDraw.sync = zoomDraw
                     :destroy.sync="destroy"

                     ></bracket-64>
        </div>
<!--          <bracket-winners :bracketFigths.sync="bracketFigths"></bracket-winners>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {baseUrlServer} from '../../api/user';
  import 'src/assets/css/tkd-theme.css';
  import 'src/assets/css/tkd-admin.css';
  import html2canvas from 'html2canvas';
  import {Swappable, Plugins, DragStartEvent, DragStopEvent} from '@shopify/draggable';
  import bracketWinners from './bracket-winners.vue';
  import DrawingHistoryModal from '../../components/DrawingHistoryModal.vue';
  
  export default {
    name: 'brackets-constructor',
    components: {
      Swappable, Plugins, DragStartEvent, DragStopEvent, 
      'bracket-winners':bracketWinners,
      'drawing-history-modal': DrawingHistoryModal
    },
    props:{
      selectedDrawCategory:Object
    },
    data() {
      return {
        baseUrlServer:'',
        swappable: null,
        // змінюється після ручного жеребкування — :key сітки, щоб Vue створив її заново (див. disableToogleSortableSheme)
        bracketGen: 0,
        colorSheme: true,
        showBracket64:false,
        showBracket32:false,
        showBracket16:false,
        showBracket8:false,
        showBracket4:false,
        showBracket2:true,
        sortableSheme: false,
        sportsmans:[],
        bracketFigths:{},
        destroy:false,
        bracketEl:null,
        bracket_size:0,
        zoomDraw:1,
        selectedFight:
          {technicalNumber:'', number:'', decision:'', winSpId:'', winSpName:'',
            red:  {spId: '', spName: '', points: '', spOrg: ''},
            blue: {spId: '', spName: '', points: '', spOrg: ''}},
        unsavedChanges: false,
        autoSaveTimeout: null,
        // раунди: перемога — 2 виграні раунди з 3
        ROUNDS_TO_WIN: 2,
        MAX_ROUNDS: 3,
        // рішення "PTG" поставлене автоматично (щоб прибрати, якщо переможця скасовано)
        autoDecision: false,
        // йде збереження бала після кліку по спортсмену — нові кліки ігноруємо, поки сітка не оновиться
        quickPointSaving: false,
        // стан автозбереження сітки після перетягування (saveBracket у Bracket*.vue)
        bracketSave: { state: 'idle', time: '' },
        unsubscribeSave: null,
        showHistoryModal: false,
      }
    },

    // computed: {
    //   // a computed getter
    //   reversedMessage: function () {
    //     // `this` points to the vm instance
    //     return this.message.split('').reverse().join('')
    //   }
    // },

    watch: {


      selectedDrawCategory: function(newVal) {
        // this.$destroy();
        // this.$forceUpdate();
        this.initCategory();
      },

      sortableSheme: function(newVal) {
        // Auto-save draft state when sortableSheme changes
        this.saveDraftState();
        this.bracketSave = { state: 'idle', time: '' };
        this.$emit('sortable-change', newVal);
      },

      //
      // selectedDrawCategory: function(newVal) {
      //   this.initCategory();
      // }
    },

    beforeMount() {
      // this.createEmptyFights();
    },
    created(){
      this.baseUrlServer = baseUrlServer;
    },
    mounted(){
      this.initCategory();
      // Check for draft state on mount
      this.restoreDraftIfExists();
      // Load history
      this.$store.dispatch('tournament/loadDrawingHistory');
      this.watchBracketSave();
      this.$root.$on('bracket-sportsman-click', this.onSportsmanClick);
    },
    updated(){
    },
    beforeDestroy() {
      // Save draft before component is destroyed
      if (this.sortableSheme && this.unsavedChanges) {
        this.saveDraftState();
      }
      // Clear auto-save timeout
      if (this.autoSaveTimeout) {
        clearTimeout(this.autoSaveTimeout);
      }
      if (this.unsubscribeSave) {
        this.unsubscribeSave();
      }
      this.$root.$off('bracket-sportsman-click', this.onSportsmanClick);
    },

    methods:{

      // позиція "лінія_індекс" → технічний номер поєдинку та кут (та сама схема, що у switch в selectBracketFight)
      fightByPosition(position) {
        const [line, index] = String(position).split('_').map(Number);
        if (!(line >= 1) || isNaN(index)) return null; // 0_0 — переможець, поєдинку немає
        return {
          tech: Math.pow(2, line - 1) - 1 + Math.floor(index / 2),
          corner: index % 2 === 0 ? 'blue' : 'red',
        };
      },

      // клік по спортсмену (BracketSportsmanItemDraw) поза ручним жеребкуванням, без попапу поєдинку:
      // +1 раунд одразу видно в сітці (лише локально), запит іде, коли визначився переможець
      onSportsmanClick({position, spId}) {
        if (this.sortableSheme || !spId || spId == 0 || this.quickPointSaving) return;
        // Після ручного перетягування DOM може випереджати drawdata; клікована позиція є джерелом істини.
        const fight = this.fightByPosition(position);
        if (!fight) return;

        this.$store.dispatch('settings/setActiveFight', String(fight.tech));
        this.selectBracketFight(String(fight.tech), false);

        const other = this.selectedFight[fight.corner === 'blue' ? 'red' : 'blue'];
        if (!other.spId) {
          // суперника немає — проходить далі без балів і без причини; вже пройшов — запит не потрібен
          if (this.getSportsmanByPosition(this.nextPosition(position)).sp_id == spId) return;
          this.selectedFight[fight.corner].points = '';
          this.selectedFight.winSpId = spId;
          this.selectedFight.decision = '';
        } else {
          // бал не змінився (2 виграні або 3 зіграні раунди) — нічого не робимо
          if (!this.changeRounds(fight.corner, 1)) return;
          this.setLocalFightPoints(position);
          if (!this.selectedFight.winSpId) return;
        }

        this.quickPointSaving = true;
        this.saveQuickPoint().finally(() => { this.quickPointSaving = false; });
      },

      // позиція переможця поєдинку в наступному колі: "лінія_індекс" → "(лінія−1)_(індекс/2)"
      nextPosition(position) {
        const [line, index] = String(position).split('_').map(Number);
        return (line - 1) + '_' + Math.floor(index / 2);
      },

      // бали поєдинку → drawdata, щоб сітка показала їх без запиту;
      // selectBracketFight читає звідти ж, тож наступний клік рахує від нових балів
      setLocalFightPoints(position) {
        const [line, index] = String(position).split('_').map(Number);
        const corners = { blue: line + '_' + (index - index % 2), red: line + '_' + (index - index % 2 + 1) };
        (this.selectedDrawCategory.drawdata || []).forEach(item => {
          const corner = item.position == corners.blue ? 'blue' : item.position == corners.red ? 'red' : null;
          if (corner) this.$set(item, 'points', this.selectedFight[corner].points);
        });
      },

      // те саме збереження, що й saveData, але без clearDrawCategory: сітку не ховаємо,
      // лише тихо перечитуємо турнір — Bracket*.vue беруть бали з drawdata і перемалюються самі
      saveQuickPoint() {
        // стор помилку не кидає, а комітить BRACKET_UPDATE_ERROR — ловимо її тут
        let failed = false;
        const unsubscribe = this.$store.subscribe((mutation) => {
          if (mutation.type === 'tournament/BRACKET_UPDATE_ERROR') failed = true;
        });
        return this.$store.dispatch('tournament/updateBracketFight', this.bracketFightParams())
          .finally(unsubscribe)
          // перечитуємо і при помилці — у сітці лишаться бали з сервера, а не локальний +1
          .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.selectedDrawCategory.tournament_id}))
          .then(() => this.$notify(failed
            ? { text: 'Бал не збережено. Перевірте зʼєднання і повторіть.', type: 'error', duration: 8000 }
            : { text: 'Бал збережено', type: 'success', duration: 2000 }));
      },

      // '' → 0; ціле 0…3 → число; інше (наприклад, старі бали 12) → null, раунди не рахуємо
      roundCount(points) {
        if (points === undefined || points === null || String(points).trim() === '') return 0;
        const value = Number(points);
        return Number.isInteger(value) && value >= 0 && value <= this.MAX_ROUNDS ? value : null;
      },

      changeRounds(corner, delta) {
        const side = this.selectedFight[corner];
        const other = this.selectedFight[corner === 'blue' ? 'red' : 'blue'];
        if (!side.spId) return false;

        const current = this.roundCount(side.points);
        const otherCount = this.roundCount(other.points);

        // бали, а не раунди (більше 3 або не ціле) — просто +1/−1, переможця визначає selectedFightChanged
        if (current === null || otherCount === null) {
          const value = Number(side.points) || 0;
          if (value + delta < 0) return false;
          side.points = String(value + delta);
          this.pointsChanged();
          return true;
        }

        if (delta > 0) {
          // без суперника раунди не рахуємо; більше 2 виграних або 3 зіграних не буває.
          // переможцю суперника можна дописати раунд (2:0 → 2:1)
          if (!other.spId) return false;
          if (current >= this.ROUNDS_TO_WIN || current + otherCount >= this.MAX_ROUNDS) return false;
        } else if (current === 0) {
          return false;
        }

        side.points = String(current + delta);
        this.applyRoundResult();
        return true;
      },

      // змінились бали: переможець — у кого більше (в обидва боки), нічия — переможця не чіпаємо
      // (selectedFightChanged лишається для ручного вибору переможця/рішення, як і було)
      pointsChanged() {
        const blue = Number(this.selectedFight.blue.points) || 0;
        const red = Number(this.selectedFight.red.points) || 0;
        if (blue === red) return;

        const winner = blue > red ? this.selectedFight.blue : this.selectedFight.red;
        if (!winner.spId) return;
        this.selectedFight.winSpId = winner.spId;
        if (!this.selectedFight.decision) {
          this.selectedFight.decision = 'PTG';
          this.autoDecision = true;
        }
      },

      applyRoundResult() {
        const blue = this.roundCount(this.selectedFight.blue.points) || 0;
        const red = this.roundCount(this.selectedFight.red.points) || 0;

        if (blue >= this.ROUNDS_TO_WIN || red >= this.ROUNDS_TO_WIN) {
          this.selectedFight.winSpId = blue >= this.ROUNDS_TO_WIN ? this.selectedFight.blue.spId : this.selectedFight.red.spId;
          // та сама причина за замовчуванням, що й у selectedFightChanged
          if (!this.selectedFight.decision) {
            this.selectedFight.decision = 'PTG';
            this.autoDecision = true;
          }
        } else {
          this.selectedFight.winSpId = '';
          if (this.autoDecision) {
            this.selectedFight.decision = '';
            this.autoDecision = false;
          }
        }
      },

      // Bracket*.vue зберігають сітку самі (tournament/saveBracket) — лише показуємо результат
      watchBracketSave() {
        this.unsubscribeSave = this.$store.subscribeAction({
          before: (action) => {
            if (action.type === 'tournament/saveBracket') {
              this.bracketSave = { state: 'saving', time: '' };
            }
          },
          after: (action) => {
            if (action.type !== 'tournament/saveBracket') return;
            // помилку стор не кидає далі, а комітить BRACKET_UPDATE_ERROR — див. subscribe нижче
            if (this.bracketSave.state === 'saving') {
              this.bracketSave = { state: 'saved', time: new Date().toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) };
              this.$emit('bracket-saved');
            }
          },
        });
        const unsubscribeMutation = this.$store.subscribe((mutation) => {
          if (mutation.type === 'tournament/BRACKET_UPDATE_ERROR' && this.bracketSave.state === 'saving') {
            this.bracketSave = { state: 'error', time: '' };
            this.$notify({ text: 'Сітку не збережено. Перевірте зʼєднання і повторіть.', type: 'error', duration: 8000 });
          }
        });
        const unsubscribeAction = this.unsubscribeSave;
        this.unsubscribeSave = () => { unsubscribeAction(); unsubscribeMutation(); };
      },

      initCategory(){

        this.disableToogleSortableSheme(false);

        if(this.selectedDrawCategory != undefined && this.selectedDrawCategory.id != undefined && this.selectedDrawCategory.sportsmans != undefined) {
          this.sportsmans = this.selectedDrawCategory.sportsmans;
        }

        this.$store.dispatch('settings/setActiveTournamentId',  this.selectedDrawCategory.tournament_id);
        this.$store.dispatch('settings/setActiveCategoryId',  this.selectedDrawCategory.id);


        let countSP = Object.keys(this.sportsmans).length;

        let count = 0;
        if(countSP < 3){
          count = 2;
        }else  if(countSP < 5){
          count = 4;
        }
        else  if(countSP < 9){
          count = 8;
        }
        else  if(countSP < 17){
          count = 16;
        }
        else  if(countSP < 33){
          count = 32;
        }
        else  if(countSP < 65){
          count = 64;
        }

        this.toogleBracket(count);
      },

      resetBracketFightForm(){
        // Reset данных

        this.selectedFight.blue.spId = '';
        this.selectedFight.blue.spName = '';
        this.selectedFight.blue.points = '';
        this.selectedFight.red.spId = '';
        this.selectedFight.red.spName = '';
        this.selectedFight.red.points = '';
        this.selectedFight.number = '';
        this.selectedFight.decision = '';
        this.autoDecision = false;

      },
      // выбор поединка/выступления
      // showModal = false — лише заповнити selectedFight (швидкий бал по кліку на спортсмена)
      selectBracketFight(fight, showModal = true){
        console.log('выбор поединка/выступления selectBracketFight', fight);
        this.selectedFight.technicalNumber = fight;

        this.resetBracketFightForm();
        let sportsmanRed = {};
        let sportsmanBlue = {};
        let nextFight = {};

        // в зависимости от технического номера поединка находинм соотвествующих спортсменов
        fight = parseInt(fight);
        switch (fight) {
          case 0:
            sportsmanBlue = this.getSportsmanByPosition('1_0');
            sportsmanRed = this.getSportsmanByPosition('1_1');
            nextFight = this.getSportsmanByPosition('0_0');
            break;
          case 1:
            sportsmanBlue = this.getSportsmanByPosition('2_0');
            sportsmanRed = this.getSportsmanByPosition('2_1');
            nextFight = this.getSportsmanByPosition('1_0');
            break;
          case 2:
            sportsmanBlue = this.getSportsmanByPosition('2_2');
            sportsmanRed = this.getSportsmanByPosition('2_3');
            nextFight = this.getSportsmanByPosition('1_1');
            break;

          case 3:
            sportsmanBlue = this.getSportsmanByPosition('3_0');
            sportsmanRed = this.getSportsmanByPosition('3_1');
            nextFight = this.getSportsmanByPosition('2_0');
            break;
          case 4:
            sportsmanBlue = this.getSportsmanByPosition('3_2');
            sportsmanRed = this.getSportsmanByPosition('3_3');
            nextFight = this.getSportsmanByPosition('2_1');
            break;

          case 5:
            sportsmanBlue = this.getSportsmanByPosition('3_4');
            sportsmanRed = this.getSportsmanByPosition('3_5');
            nextFight = this.getSportsmanByPosition('2_2');
            break;

          case 6:
            sportsmanBlue = this.getSportsmanByPosition('3_6');
            sportsmanRed = this.getSportsmanByPosition('3_7');
            nextFight = this.getSportsmanByPosition('2_3');
            break;

          case 7:
            sportsmanBlue = this.getSportsmanByPosition('4_0');
            sportsmanRed = this.getSportsmanByPosition('4_1');
            nextFight = this.getSportsmanByPosition('3_0');
            break;
          case 8:
            sportsmanBlue = this.getSportsmanByPosition('4_2');
            sportsmanRed = this.getSportsmanByPosition('4_3');
            nextFight = this.getSportsmanByPosition('3_1');
            break;
          case 9:
            sportsmanBlue = this.getSportsmanByPosition('4_4');
            sportsmanRed = this.getSportsmanByPosition('4_5');
            nextFight = this.getSportsmanByPosition('3_2');
            break;
          case 10:
            sportsmanBlue = this.getSportsmanByPosition('4_6');
            sportsmanRed = this.getSportsmanByPosition('4_7');
            nextFight = this.getSportsmanByPosition('3_3');
            break;
          case 11:
            sportsmanBlue = this.getSportsmanByPosition('4_8');
            sportsmanRed = this.getSportsmanByPosition('4_9');
            nextFight = this.getSportsmanByPosition('3_4');
            break;
          case 12:
            sportsmanBlue = this.getSportsmanByPosition('4_10');
            sportsmanRed = this.getSportsmanByPosition('4_11');
            nextFight = this.getSportsmanByPosition('3_5');
            break;
          case 13:
            sportsmanBlue = this.getSportsmanByPosition('4_12');
            sportsmanRed = this.getSportsmanByPosition('4_13');
            nextFight = this.getSportsmanByPosition('3_6');
            break;
          case 14:
            sportsmanBlue = this.getSportsmanByPosition('4_14');
            sportsmanRed = this.getSportsmanByPosition('4_15');
            nextFight = this.getSportsmanByPosition('3_7');
            break;
          case 15:
            sportsmanBlue = this.getSportsmanByPosition('5_0');
            sportsmanRed = this.getSportsmanByPosition('5_1');
            nextFight = this.getSportsmanByPosition('4_0');
            break;
          case 16:
            sportsmanBlue = this.getSportsmanByPosition('5_2');
            sportsmanRed = this.getSportsmanByPosition('5_3');
            nextFight = this.getSportsmanByPosition('4_1');
            break;
          case 17:
            sportsmanBlue = this.getSportsmanByPosition('5_4');
            sportsmanRed = this.getSportsmanByPosition('5_5');
            nextFight = this.getSportsmanByPosition('4_2');
            break;
          case 18:
            sportsmanBlue = this.getSportsmanByPosition('5_6');
            sportsmanRed = this.getSportsmanByPosition('5_7');
            nextFight = this.getSportsmanByPosition('4_3');
            break;
          case 19:
            sportsmanBlue = this.getSportsmanByPosition('5_8');
            sportsmanRed = this.getSportsmanByPosition('5_9');
            nextFight = this.getSportsmanByPosition('4_4');
            break;
          case 20:
            sportsmanBlue = this.getSportsmanByPosition('5_10');
            sportsmanRed = this.getSportsmanByPosition('5_11');
            nextFight = this.getSportsmanByPosition('4_5');
            break;
          case 21:
            sportsmanBlue = this.getSportsmanByPosition('5_12');
            sportsmanRed = this.getSportsmanByPosition('5_13');
            nextFight = this.getSportsmanByPosition('4_6');
            break;
          case 22:
            sportsmanBlue = this.getSportsmanByPosition('5_14');
            sportsmanRed = this.getSportsmanByPosition('5_15');
            nextFight = this.getSportsmanByPosition('4_7');
            break;
          case 23:
            sportsmanBlue = this.getSportsmanByPosition('5_16');
            sportsmanRed = this.getSportsmanByPosition('5_17');
            nextFight = this.getSportsmanByPosition('4_8');
            break;
          case 24:
            sportsmanBlue = this.getSportsmanByPosition('5_18');
            sportsmanRed = this.getSportsmanByPosition('5_19');
            nextFight = this.getSportsmanByPosition('4_9');
            break;
          case 25:
            sportsmanBlue = this.getSportsmanByPosition('5_20');
            sportsmanRed = this.getSportsmanByPosition('5_21');
            nextFight = this.getSportsmanByPosition('4_10');
            break;
          case 26:
            sportsmanBlue = this.getSportsmanByPosition('5_22');
            sportsmanRed = this.getSportsmanByPosition('5_23');
            nextFight = this.getSportsmanByPosition('4_11');
            break;
          case 27:
            sportsmanBlue = this.getSportsmanByPosition('5_24');
            sportsmanRed = this.getSportsmanByPosition('5_25');
            nextFight = this.getSportsmanByPosition('4_12');
            break;
          case 28:
            sportsmanBlue = this.getSportsmanByPosition('5_26');
            sportsmanRed = this.getSportsmanByPosition('5_27');
            nextFight = this.getSportsmanByPosition('4_13');
            break;
          case 29:
            sportsmanBlue = this.getSportsmanByPosition('5_28');
            sportsmanRed = this.getSportsmanByPosition('5_29');
            nextFight = this.getSportsmanByPosition('4_14');
            break;
          case 30:
            sportsmanBlue = this.getSportsmanByPosition('5_30');
            sportsmanRed = this.getSportsmanByPosition('5_31');
            nextFight = this.getSportsmanByPosition('4_15');
            break;

          case 31:
            sportsmanBlue = this.getSportsmanByPosition('6_0');
            sportsmanRed = this.getSportsmanByPosition('6_1');
            nextFight = this.getSportsmanByPosition('5_0');
            break;
          case 32:
            sportsmanBlue = this.getSportsmanByPosition('6_2');
            sportsmanRed = this.getSportsmanByPosition('6_3');
            nextFight = this.getSportsmanByPosition('5_1');
            break;
          case 33:
            sportsmanBlue = this.getSportsmanByPosition('6_4');
            sportsmanRed = this.getSportsmanByPosition('6_5');
            nextFight = this.getSportsmanByPosition('5_2');
            break;

          case 34:
            sportsmanBlue = this.getSportsmanByPosition('6_6');
            sportsmanRed = this.getSportsmanByPosition('6_7');
            nextFight = this.getSportsmanByPosition('5_3');
            break;

          case 35:
            sportsmanBlue = this.getSportsmanByPosition('6_8');
            sportsmanRed = this.getSportsmanByPosition('6_9');
            nextFight = this.getSportsmanByPosition('5_4');
            break;
          case 36:
            sportsmanBlue = this.getSportsmanByPosition('6_10');
            sportsmanRed = this.getSportsmanByPosition('6_11');
            nextFight = this.getSportsmanByPosition('5_5');
            break;
          case 37:
            sportsmanBlue = this.getSportsmanByPosition('6_12');
            sportsmanRed = this.getSportsmanByPosition('6_13');
            nextFight = this.getSportsmanByPosition('5_6');
            break;
          case 38:
            sportsmanBlue = this.getSportsmanByPosition('6_14');
            sportsmanRed = this.getSportsmanByPosition('6_15');
            nextFight = this.getSportsmanByPosition('5_7');
            break;

          case 39:
            sportsmanBlue = this.getSportsmanByPosition('6_16');
            sportsmanRed = this.getSportsmanByPosition('6_17');
            nextFight = this.getSportsmanByPosition('5_8');
            break;

          case 40:
            sportsmanBlue = this.getSportsmanByPosition('6_18');
            sportsmanRed = this.getSportsmanByPosition('6_19');
            nextFight = this.getSportsmanByPosition('5_9');
            break;

          case 41:
            sportsmanBlue = this.getSportsmanByPosition('6_20');
            sportsmanRed = this.getSportsmanByPosition('6_21');
            nextFight = this.getSportsmanByPosition('5_10');
            break;

          case 42:
            sportsmanBlue = this.getSportsmanByPosition('6_22');
            sportsmanRed = this.getSportsmanByPosition('6_23');
            nextFight = this.getSportsmanByPosition('5_11');
            break;

          case 43:
            sportsmanBlue = this.getSportsmanByPosition('6_24');
            sportsmanRed = this.getSportsmanByPosition('6_25');
            nextFight = this.getSportsmanByPosition('5_12');
            break;

          case 44:
            sportsmanBlue = this.getSportsmanByPosition('6_26');
            sportsmanRed = this.getSportsmanByPosition('6_27');
            nextFight = this.getSportsmanByPosition('5_13');
            break;

          case 45:
            sportsmanBlue = this.getSportsmanByPosition('6_28');
            sportsmanRed = this.getSportsmanByPosition('6_29');
            nextFight = this.getSportsmanByPosition('5_14');
            break;


          case 46:
            sportsmanBlue = this.getSportsmanByPosition('6_30');
            sportsmanRed = this.getSportsmanByPosition('6_31');
            nextFight = this.getSportsmanByPosition('5_15');
            break;

          case 47:
            sportsmanBlue = this.getSportsmanByPosition('6_32');
            sportsmanRed = this.getSportsmanByPosition('6_33');
            nextFight = this.getSportsmanByPosition('5_16');
            break;

          case 48:
            sportsmanBlue = this.getSportsmanByPosition('6_34');
            sportsmanRed = this.getSportsmanByPosition('6_35');
            nextFight = this.getSportsmanByPosition('5_17');
            break;

          case 49:
            sportsmanBlue = this.getSportsmanByPosition('6_36');
            sportsmanRed = this.getSportsmanByPosition('6_37');
            nextFight = this.getSportsmanByPosition('5_18');
            break;
          case 50:
            sportsmanBlue = this.getSportsmanByPosition('6_38');
            sportsmanRed = this.getSportsmanByPosition('6_39');
            nextFight = this.getSportsmanByPosition('5_19');
            break;
          case 51:
            sportsmanBlue = this.getSportsmanByPosition('6_40');
            sportsmanRed = this.getSportsmanByPosition('6_41');
            nextFight = this.getSportsmanByPosition('5_20');
            break;
          case 52:
            sportsmanBlue = this.getSportsmanByPosition('6_42');
            sportsmanRed = this.getSportsmanByPosition('6_43');
            nextFight = this.getSportsmanByPosition('5_21');
            break;
          case 53:
            sportsmanBlue = this.getSportsmanByPosition('6_44');
            sportsmanRed = this.getSportsmanByPosition('6_45');
            nextFight = this.getSportsmanByPosition('5_22');
            break;
          case 54:
            sportsmanBlue = this.getSportsmanByPosition('6_46');
            sportsmanRed = this.getSportsmanByPosition('6_47');
            nextFight = this.getSportsmanByPosition('5_23');
            break;
          case 55:
            sportsmanBlue = this.getSportsmanByPosition('6_48');
            sportsmanRed = this.getSportsmanByPosition('6_49');
            nextFight = this.getSportsmanByPosition('5_24');
            break;
          case 56:
            sportsmanBlue = this.getSportsmanByPosition('6_50');
            sportsmanRed = this.getSportsmanByPosition('6_51');
            nextFight = this.getSportsmanByPosition('5_25');
            break;
          case 57:
            sportsmanBlue = this.getSportsmanByPosition('6_52');
            sportsmanRed = this.getSportsmanByPosition('6_53');
            nextFight = this.getSportsmanByPosition('5_26');
            break;
          case 58:
            sportsmanBlue = this.getSportsmanByPosition('6_54');
            sportsmanRed = this.getSportsmanByPosition('6_55');
            nextFight = this.getSportsmanByPosition('5_27');
            break;
          case 59:
            sportsmanBlue = this.getSportsmanByPosition('6_56');
            sportsmanRed = this.getSportsmanByPosition('6_57');
            nextFight = this.getSportsmanByPosition('5_28');
            break;
          case 60:
            sportsmanBlue = this.getSportsmanByPosition('6_58');
            sportsmanRed = this.getSportsmanByPosition('6_59');
            nextFight = this.getSportsmanByPosition('5_29');
            break;
          case 61:
            sportsmanBlue = this.getSportsmanByPosition('6_60');
            sportsmanRed = this.getSportsmanByPosition('6_61');
            nextFight = this.getSportsmanByPosition('5_30');
            break;
          case 62:
            sportsmanBlue = this.getSportsmanByPosition('6_62');
            sportsmanRed = this.getSportsmanByPosition('6_63');
            nextFight = this.getSportsmanByPosition('5_31');
            break;


          // case 3:
          //   sportsmanBlue = this.getSportsmanByPosition('2_2');
          //   sportsmanRed = this.getSportsmanByPosition('2_3');
          //   break;

          default:
            console.log('default', 'fight', fight);
            break;
        }

        if(sportsmanBlue.id != undefined){
          this.selectedFight.blue.spId = sportsmanBlue.id;
          this.selectedFight.blue.spName = sportsmanBlue.name;
          this.selectedFight.blue.points = sportsmanBlue.points;
        }
        if(sportsmanRed.id != undefined){
          this.selectedFight.red.spId = sportsmanRed.id;
          this.selectedFight.red.spName = sportsmanRed.name;
          this.selectedFight.red.points = sportsmanRed.points;
        }

        if(!this.selectedFight.red.spId && this.selectedFight.blue.spId){
          this.selectedFight.winSpId = this.selectedFight.blue.spId
        }

          if(!this.selectedFight.blue.spId && this.selectedFight.red.spId){
          this.selectedFight.winSpId = this.selectedFight.red.spId
        }

          // document.getElementById('selectedFightnumber').focus()



        if(nextFight){
          this.selectedFight.number = nextFight.number;
          this.selectedFight.winSpId = nextFight.sp_id;
          this.selectedFight.decision = nextFight.decision == undefined ? "":nextFight.decision;
        }

        console.log('nextFight', nextFight);
        console.log('fight', fight);
        console.log('this.selectedFight', this.selectedFight);
        console.log('this.selectedFight.decision', this.selectedFight.decision);
        // console.log('selectedFight.technicalNumber', this.selectedFight.technicalNumber);
        // console.log('selectedFight.technicalNumber', this.selectedFight.technicalNumber.length);
        // console.log('sportsmanBlue', sportsmanBlue);
        // console.log('sportsmanRed', sportsmanRed);
        // console.log('this.selectedFight', this.selectedFight);



        if (showModal) this.$modal.show('event-update-form-modal');
        // Set focus in fight field

      },

      getSportsmanByPosition(position){
        // ищим спортсмена с текущей позицией
        let result = {name: '', id: 0, organization: ' ', points: ''};


        for (let i = 0; i <this.selectedDrawCategory.drawdata.length ; i++) {
          if(this.selectedDrawCategory.drawdata[i].position == position){
            result.id = this.selectedDrawCategory.drawdata[i].sp_id;
            result.name = this.selectedDrawCategory.drawdata[i].name;
            result.organization = this.selectedDrawCategory.drawdata[i].organization;
            result.decision = this.selectedDrawCategory.drawdata[i].decision;
            result.points = this.selectedDrawCategory.drawdata[i].points;
            result.number = this.selectedDrawCategory.drawdata[i].number;
            result.sp_id = this.selectedDrawCategory.drawdata[i].sp_id;

            return  result;
            break;
          }
        }
        return false;
      },

      selectedFightChanged(){
        console.log(' UserBracketsContructor selectedFightChanged' , this.selectedFight);

        // порівнюємо як числа: рядки "10" < "9"
        const redPoints = Number(this.selectedFight.red.points) || 0;
        const bluePoints = Number(this.selectedFight.blue.points) || 0;

        if(redPoints > bluePoints){
          this.selectedFight.winSpId = this.selectedFight.red.spId
          // this.selectedFight.decision = "PTG"

          if(!this.selectedFight.decision){
            this.selectedFight.decision = "PTG"
          }
        }
        if( !this.selectedFight.winSpId && redPoints < bluePoints){
          this.selectedFight.winSpId = this.selectedFight.blue.spId
          // this.selectedFight.decision = "PTG"
          if(!this.selectedFight.decision){
            this.selectedFight.decision = "PTG"
          }
        }



        // this.saveData();
      },

      // переключение на цветной режим
      toogleColorSheme() {
        console.log('toogleColorSheme');
        if (this.colorSheme === true) {
          this.colorSheme = false;
        } else if (this.colorSheme !== true) {
          this.colorSheme = true;
        }
      },

      /**
       * count sportsmans for brackets 2,4,8,16,32
       * @param countSp
       */
      toogleBracket(countSp) {
        console.log('toogleBracket  '+countSp);
        this.showBracket2 = false;
        this.showBracket4 = false;
        this.showBracket8 = false;
        this.showBracket16 = false;
        this.showBracket32 = false;
        this.showBracket64 = false;
        switch (countSp) {
          case 2:
            this.showBracket2 = true;
            this.bracket_size = 2;
            break;
          case 4:
            this.showBracket4 = true;
            this.bracket_size = 4;
            break;
          case 8:
            this.showBracket8 = true;
            this.bracket_size = 8
            break;
          case 16:
            this.showBracket16 = true;
            this.bracket_size = 16;
            break;
          case 32:
            this.showBracket32 = true;
            this.bracket_size = 32;
            break;
          case 64:
            this.showBracket64 = true;
            this.bracket_size = 64;
            break;
        }

        this.$store.dispatch('settings/setActiveBracketSize',  this.bracket_size);

        this.bracketEl = 'bracket-items-'+this.bracket_size;

      },

      // получение изображения сетки
      getImage() {
        let element = document.getElementById("bracket-image-block");

        window.scrollTo(0,0);
        var scrollHeight = Math.max(
          element.scrollHeight, element.scrollHeight,
          element.offsetHeight, element.offsetHeight,
          element.clientHeight, element.clientHeight
        );

        let selectedDrawCategoryName = this.selectedDrawCategory.fullname != undefined ? this.selectedDrawCategory.fullname :'';
        html2canvas(element,{
          windowHeight: window.outerHeight + window.innerHeight,
          }
         ).then(canvas => {
          this.saveAs(canvas.toDataURL('image/png'), selectedDrawCategoryName +'_bracket_v2.png');
        });
      },


      // включение или отключения режима жеребьевки путем добавления класа к елементам которые нужно передвигать
      toogleSortableSheme() {
        console.log('toogleSortableSheme');
        
        // Check if bracket is rendered before allowing toggle
        if (!this.selectedDrawCategory || !this.selectedDrawCategory.id) {
          this.$notify({
            text: 'Категорія не вибрана.',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 3000,
            type: 'warning'
          });
          return;
        }
        
        if (this.sortableSheme === true) {
          this.disableToogleSortableSheme();
        } else if (this.sortableSheme !== true) {
          this.enableToogleSortableSheme();
        }

        // this.resortBracket();
      },


      clearBracket()
      {
        console.log('clearBracket');

        let params = {
          tournament_id:this.selectedDrawCategory.tournament_id,
          category:this.selectedDrawCategory.id,
        };
        // autoSortableBracketAll
        if (window.confirm("Скидання жеребкування?")) {
          // Add to history before clearing
          this.addToHistory('Рестарт сітки', 'bracket_reset');

          this.$notify(
              {
                text: 'Скидання жеребкування',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                duration: 10000,
                speed: 1000,
                type: 'error'
              })

          // Clear draft when resetting bracket
          this.clearDraftState();

          this.$store.dispatch('tournament/clearBracket', params).then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: params.tournament_id}))
              .then(() => this.updateBracket());
        }
      },

      // Автоматическа жеребьевка
      toogleAutoSortableSheme(type) {
        console.log('toogleAutoSortableSheme');
        this.$notify(
            {
              text: 'Старт автоматичного жеребкування',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 10000,
              speed: 1000,
              type: 'warn'
            })

        let params = {
          tournament_id:this.selectedDrawCategory.tournament_id,
          category:this.selectedDrawCategory.id,
          bracket_size: this.bracket_size,
          time:new Date().getTime(),
          type: type,
        };

        if (window.confirm("Прожерубкувати автоматично?")) {
          // Add to history before auto-drawing
          this.addToHistory('Автоматичне жеребкування протокола', 'auto_drawing', { drawType: type });

          // Clear draft when auto-drawing
          this.clearDraftState();

          this.$store.dispatch('tournament/autoSortableBracket', params).then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: params.tournament_id}))
              .then(() => this.updateBracket());
        }

        // this.$store.dispatch('tournament/autoSortableBracket', params).then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: params.tournament_id}))
        //   .then(() => window.location.reload());


        // if (this.sortableSheme === true) {
        //   this.disableToogleSortableSheme();
        // } else if (this.sortableSheme !== true) {
        //   this.enableToogleSortableSheme();
        // }

      },

      enableToogleSortableSheme(){
        console.log('enableToogleSortableSheme');
        
        // Wait for next tick to ensure DOM is rendered
        this.$nextTick(() => {
          let round0 = document.getElementById('round-0');
          
          if(!round0) {
            console.warn('round-0 element not found. Bracket may not be rendered yet.');
            this.$notify({
              text: 'Сітка ще не завантажена. Спробуйте ще раз через мить.',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 5000,
              type: 'warning'
            });
            this.sortableSheme = false;
            return;
          }
          
          let items = round0.getElementsByClassName('sp-item');
          
          if(items.length === 0) {
            console.warn('No sp-item elements found in round-0');
            this.$notify({
              text: 'Немає елементів для переміщення в сітці.',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 5000,
              type: 'warning'
            });
            this.sortableSheme = false;
            return;
          }
          
          this.sortableSheme = true;
          
          for (let k = 0; k < items.length; k++) {
            if (items[k].classList) {
              items[k].classList.add("sortable-drag-item");
            }
          }
          
          // Add to history only if successfully enabled
          this.addToHistory('Увімкнено ручне жеребкування', 'manual_drawing');
          
          this.$notify({
            text: 'Ручне жеребкування увімкнено. Перетягуйте спортсменів в сітку.',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 5000,
            type: 'success'
          });
        });
      },

      syncFirstRoundFromDom(round0) {
        if (!round0 || !this.selectedDrawCategory || !this.selectedDrawCategory.drawdata) return;

        const bracketSize = Number(this.bracket_size || this.activeBracketSize);
        const firstLine = Math.log2(bracketSize);
        if (!Number.isInteger(firstLine)) return;

        const sourceList = this.selectedDrawCategory.sportsmans || [];
        const sportsmans = Array.isArray(sourceList) ? sourceList : Object.values(sourceList);
        const sportsmanById = id => sportsmans.find(item => Number(item.id) === Number(id));
        const groups = round0.getElementsByClassName('group');
        let positionIndex = 0;

        for (let i = 0; i < groups.length; i++) {
          const items = Array.from(groups[i].getElementsByClassName('sp-item'))
            .filter(item => !item.classList.contains('draggable--original'));

          for (let j = 0; j < items.length; j++) {
            const position = firstLine + '_' + positionIndex++;
            const target = this.selectedDrawCategory.drawdata.find(item => item.position == position);
            if (!target) continue;

            const spId = Number(items[j].getAttribute('data-sp')) || 0;
            const previousSpId = Number(target.sp_id) || 0;
            const sportsman = spId ? sportsmanById(spId) : null;

            this.$set(target, 'sp_id', spId);
            this.$set(target, 'name', sportsman ? sportsman.name : '');
            this.$set(target, 'organization', sportsman ? sportsman.organization : '');
            this.$set(target, 'oblast', sportsman ? sportsman.oblast : '');

            if (previousSpId !== spId) {
              this.$set(target, 'points', '');
              this.$set(target, 'decision', '');
            }
          }
        }
      },

      disableToogleSortableSheme(showNotification = true){
        this.$nextTick(() => {
          let round0 = document.getElementById('round-0');
          
          if(!round0) {
            console.warn('round-0 element not found when disabling.');
            this.sortableSheme = false;
            return;
          }
          
          let items = round0.getElementsByClassName('sp-item');
          const wasSortable = this.sortableSheme;
          this.syncFirstRoundFromDom(round0);
          this.sortableSheme = false;

          for (let k = 0; k < items.length; k++) {
            if (items[k].classList) {
              items[k].classList.remove("sortable-drag-item");
            }
          }

          // Swappable переставляє DOM-вузли поза Vue: компонент спортсмена лишається зі старим technicalNumber,
          // і клік по ньому рахує бал іншій позиції. Перемонтовуємо сітку — DOM знову збігається з drawdata.
          if (wasSortable) {
            this.bracketGen++;
          }

          // Suppress the toast for internal resets caused by category/data refreshes.
          if (showNotification) {
            this.$notify({
              text: 'Ручне жеребкування вимкнено.',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 3000,
              type: 'info'
            });
          }
        });
      },


      saveAs(uri, filename) {
        var link = document.createElement('a');
        link.download = 'download';
        if (typeof link.download === 'string') {
          link.href = uri;
          link.target = '_blank';
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.open(uri);
        }
      },

      createEmptyFights(){
      },
      bracketFightParams(){
        return {
          tournament_id:this.selectedDrawCategory.tournament_id,
          category:this.selectedDrawCategory.id,
          technicalNumber: this.selectedFight.technicalNumber,
          number: this.selectedFight.number,
          decision: this.selectedFight.decision,
          winSpId: this.selectedFight.winSpId !=null ? this.selectedFight.winSpId:'',
          winSpName: this.selectedFight.winSpName,
          red_id: this.selectedFight.red.spId,
          blue_id: this.selectedFight.blue.spId,
          red_points: this.selectedFight.red.points,
          blue_points: this.selectedFight.blue.points,
          bracket_size: this.bracket_size,
          time:new Date().getTime(),
        };
      },
      saveData(){
        // send data to

        let params = this.bracketFightParams();

        this.$notify(
            {
              text: 'Збереження',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 10000,
              speed: 1000,
              type: 'warning'
            })
        console.log('Save params ', params);

        return this.$store.dispatch('tournament/updateBracketFight', params).then(() => this.updateBracket());

      },

      clearDrawCategory()
      {
        this.showBracket2 = false;
        this.showBracket4 = false;
        this.showBracket8 = false;
        this.showBracket16 = false;
        this.showBracket32 = false;
        this.showBracket64 = false;
        this.destroy = true;
        this.$store.dispatch('tournament/fetchTournamentOneFull', {id:this.selectedDrawCategory.tournament_id})
        this.$forceUpdate();
        // this.destroy = false;


      },
      updateBracket()
      {
        this.clearDrawCategory()
        // this.initCategory();

        this.$notify(
            {
              text: 'Дані оновлено',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              duration: 10000,
              speed: 1000,
              type: 'success'
            })

        this.$modal.hide('event-update-form-modal');

        // alert('Дані оновлено');
        // this.notifyVue('top', 'right')

        // this.$notifications.notify(
        //     {
        //       message: `<span>Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for every web developer.</span>`,
        //       icon: 'nc-icon nc-app',
        //       horizontalAlign: 'right',
        //       verticalAlign: 'top',
        //       type: 'success'
        //     })

        // window.location.reload();
      },
      handleChange(){



      },

      // Draft management methods
      saveDraftState() {
        if (!this.selectedDrawCategory || !this.selectedDrawCategory.id) return;
        
        const draftState = {
          sortableSheme: this.sortableSheme,
          unsavedChanges: this.unsavedChanges,
          categoryId: this.selectedDrawCategory.id,
          categoryName: this.selectedDrawCategory.fullname,
        };

        this.$store.dispatch('tournament/saveDrawingDraft', {
          categoryId: this.selectedDrawCategory.id,
          draftState
        });

        console.log('Draft saved for category:', this.selectedDrawCategory.id);
      },

      restoreDraftIfExists() {
        if (!this.selectedDrawCategory || !this.selectedDrawCategory.id) return;
        
        const draft = this.$store.getters['tournament/getDrawingDraft'](this.selectedDrawCategory.id);
        
        if (draft) {
          // Show notification about existing draft
          this.$notify({
            text: `Знайдено чернетку жеребкування від ${new Date(draft.timestamp).toLocaleString('uk-UA')}`,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 8000,
            type: 'info'
          });

          // Restore the draft state
          if (draft.sortableSheme) {
            this.sortableSheme = draft.sortableSheme;
            if (draft.sortableSheme === true) {
              this.enableToogleSortableSheme();
            }
          }
        }
      },

      clearDraftState() {
        if (!this.selectedDrawCategory || !this.selectedDrawCategory.id) return;
        
        this.$store.dispatch('tournament/clearDrawingDraft', this.selectedDrawCategory.id);
        this.unsavedChanges = false;
        
        console.log('Draft cleared for category:', this.selectedDrawCategory.id);
      },

      markUnsavedChanges() {
        this.unsavedChanges = true;
        // Debounced auto-save
        if (this.autoSaveTimeout) {
          clearTimeout(this.autoSaveTimeout);
        }
        this.autoSaveTimeout = setTimeout(() => {
          this.saveDraftState();
        }, 2000); // Auto-save after 2 seconds of inactivity
      },

      // History tracking methods
      addToHistory(description, action, additionalData = {}) {
        if (!this.selectedDrawCategory || !this.selectedDrawCategory.id) return;

        // Count sportsmen
        const sportsmansCount = this.selectedDrawCategory.sportsmans ? 
          Object.keys(this.selectedDrawCategory.sportsmans).length : 0;
        
        const inBracketCount = this.selectedDrawCategory.drawdata ? 
          this.selectedDrawCategory.drawdata.filter(d => d.sp_id > 0).length : 0;

        // Get previous version for comparison
        const previousHistory = this.$store.getters['tournament/getDrawingHistory'](this.selectedDrawCategory.id);
        const previousVersion = previousHistory.length > 0 ? previousHistory[previousHistory.length - 1] : null;
        
        // Generate change details
        const changeDetails = this.generateChangeDetails(previousVersion);

        const historyEntry = {
          description,
          action,
          sportsmansCount,
          inBracketCount,
          drawdata: this.selectedDrawCategory.drawdata ? 
            JSON.parse(JSON.stringify(this.selectedDrawCategory.drawdata)) : [],
          categoryName: this.selectedDrawCategory.fullname,
          changeDetails, // Add detailed change information
          ...additionalData
        };

        this.$store.dispatch('tournament/addDrawingHistory', {
          categoryId: this.selectedDrawCategory.id,
          historyEntry
        });

        console.log('Added to history:', description, changeDetails);
      },

      generateChangeDetails(previousVersion) {
        if (!previousVersion) {
          return '\u041f\u0435\u0440\u0448\u0430 \u0432\u0435\u0440\u0441\u0456\u044f \u0436\u0435\u0440\u0435\u0431\u043a\u0443\u0432\u0430\u043d\u043d\u044f';
        }

        const changes = [];
        const currentData = this.selectedDrawCategory.drawdata || [];
        const previousData = previousVersion.drawdata || [];

        // Track specific sportsmen changes
        const addedSportsmen = [];
        const removedSportsmen = [];
        const movedSportsmen = [];

        // Create maps for easier comparison
        const currentMap = new Map(); // spId -> {position, name}
        const previousMap = new Map();

        currentData.forEach(item => {
          if (item.sp_id > 0) {
            currentMap.set(item.sp_id, {
              position: item.position,
              name: item.name || `ID ${item.sp_id}`
            });
          }
        });

        previousData.forEach(item => {
          if (item.sp_id > 0) {
            previousMap.set(item.sp_id, {
              position: item.position,
              name: item.name || `ID ${item.sp_id}`
            });
          }
        });

        // Find added sportsmen
        currentMap.forEach((data, spId) => {
          if (!previousMap.has(spId)) {
            addedSportsmen.push(data.name);
          } else if (previousMap.get(spId).position !== data.position) {
            const prevPos = previousMap.get(spId).position;
            const currPos = data.position;
            movedSportsmen.push(`${data.name} (${prevPos} \u2192 ${currPos})`);
          }
        });

        // Find removed sportsmen
        previousMap.forEach((data, spId) => {
          if (!currentMap.has(spId)) {
            removedSportsmen.push(data.name);
          }
        });

        // Build detailed change description
        const detailedChanges = [];

        if (addedSportsmen.length > 0) {
          const names = addedSportsmen.length <= 3 
            ? addedSportsmen.join(', ')
            : `${addedSportsmen.slice(0, 3).join(', ')} \u0442\u0430 \u0449\u0435 ${addedSportsmen.length - 3}`;
          detailedChanges.push(`<strong>+${addedSportsmen.length} \u0434\u043e\u0434\u0430\u043d\u043e:</strong> ${names}`);
        }

        if (removedSportsmen.length > 0) {
          const names = removedSportsmen.length <= 3 
            ? removedSportsmen.join(', ')
            : `${removedSportsmen.slice(0, 3).join(', ')} \u0442\u0430 \u0449\u0435 ${removedSportsmen.length - 3}`;
          detailedChanges.push(`<strong>-${removedSportsmen.length} \u0432\u0438\u0434\u0430\u043b\u0435\u043d\u043e:</strong> ${names}`);
        }

        if (movedSportsmen.length > 0) {
          const names = movedSportsmen.length <= 3 
            ? movedSportsmen.join(', ')
            : `${movedSportsmen.slice(0, 3).join(', ')} \u0442\u0430 \u0449\u0435 ${movedSportsmen.length - 3}`;
          detailedChanges.push(`<strong>\u21c4${movedSportsmen.length} \u043f\u0435\u0440\u0435\u043c\u0456\u0449\u0435\u043d\u043e:</strong> ${names}`);
        }

        // Simple summary for quick view
        const summary = [];
        if (addedSportsmen.length > 0) summary.push(`+${addedSportsmen.length}`);
        if (removedSportsmen.length > 0) summary.push(`-${removedSportsmen.length}`);
        if (movedSportsmen.length > 0) summary.push(`\u21c4${movedSportsmen.length}`);

        return {
          summary: summary.length > 0 ? summary.join(' ') : '\u0411\u0435\u0437 \u0437\u043c\u0456\u043d',
          detailed: detailedChanges.length > 0 ? detailedChanges.join('<br>') : '\u0411\u0435\u0437 \u0437\u043c\u0456\u043d',
          addedSportsmen,
          removedSportsmen,
          movedSportsmen
        };
      },

      openHistoryModal() {
        this.showHistoryModal = true;
      },

      closeHistoryModal() {
        this.showHistoryModal = false;
      },

      handleViewVersion(entry) {
        // Show version details
        let changeInfo = '';
        if (entry.changeDetails) {
          // Handle both old string format and new object format
          const details = typeof entry.changeDetails === 'string' 
            ? entry.changeDetails 
            : entry.changeDetails.detailed;
          changeInfo = `<br><br><strong>\u0417\u043c\u0456\u043d\u0438:</strong><br>${details}`;
        }
        
        this.$notify({
          text: `<strong>\u0412\u0435\u0440\u0441\u0456\u044f ${entry.version}:</strong> ${entry.description}<br>\u0421\u043f\u043e\u0440\u0442\u0441\u043c\u0435\u043d\u0456\u0432: ${entry.sportsmansCount}, \u0412 \u0441\u0456\u0442\u0446\u0456: ${entry.inBracketCount}${changeInfo}`,
          horizontalAlign: 'right',
          verticalAlign: 'top',
          duration: 12000,
          type: 'info'
        });
      },

      handleRestoreVersion(entry) {
        // Save current state to history before restoring
        this.addToHistory('Збережено перед відновленням версії ' + entry.version, 'backup_before_restore');

        // Restore the version by updating bracket
        const params = {
          tournament_id: this.selectedDrawCategory.tournament_id,
          category: this.selectedDrawCategory.id,
          drawdata: entry.drawdata,
          restore_version: entry.version,
          time: new Date().getTime(),
        };

        this.$notify({
          text: `Відновлення версії ${entry.version}...`,
          horizontalAlign: 'right',
          verticalAlign: 'top',
          duration: 5000,
          type: 'warning'
        });

        // Note: You'll need to create a new API endpoint for restoring versions
        // For now, we'll just add to history and reload
        this.addToHistory(`Відновлено версію ${entry.version}`, 'version_restored', {
          restoredFrom: entry.version
        });

        this.$store.dispatch('tournament/fetchTournamentOneFull', {id: params.tournament_id})
          .then(() => {
            this.updateBracket();
            this.closeHistoryModal();
          });
      },

      // addEmptySportsman(count){
      //   for (let i=0; i <count; i++){
      //     this.sportsmans.push({name: '', id: i, organization: ' ', points: ''});
      //   }
      // }
    },

  }
</script>

<style lang="scss">

</style>

<style scoped>
.bracket-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  margin: 4px 0 12px;
  padding: 12px 14px;
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  background: var(--tkd-surface);
  box-shadow: var(--tkd-shadow);
}

.bracket-toolbar-group { display: flex; flex-wrap: wrap; gap: 8px; }

/* рестарт — окремо праворуч, щоб не натиснути випадково */
.bracket-toolbar-end { margin-left: auto; padding-left: 16px; border-left: 1px solid var(--tkd-border); }

/* Попап результату поєдинку */
.fight-number-field { max-width: 200px; }

.fight-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 8px 8px 8px 12px;
  border: 1px solid var(--tkd-border);
  border-left: 4px solid #0057b7;
  border-radius: var(--tkd-radius);
  background: var(--tkd-surface);
}

.fight-row.is-red { border-left-color: #d92d20; }

.corner-tag {
  flex-shrink: 0;
  width: 70px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0057b7;
}

.is-red .corner-tag { color: #d92d20; }

.fight-row-name {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  text-transform: none;
  color: var(--tkd-text);
  overflow-wrap: anywhere;
}

.fight-points-input { flex-shrink: 0; width: 80px; text-align: center; font-size: 18px; font-weight: 800; }

@media (max-width: 480px) {
  .fight-row { flex-wrap: wrap; }
  .corner-tag { width: auto; }
  .fight-row-name { flex-basis: 100%; order: 3; }
  .fight-points-input { margin-left: auto; }
}

.manual-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border: 1.5px solid var(--adm-ok-border);
  border-radius: var(--tkd-radius-lg);
  background: var(--adm-ok-bg);
  font-family: var(--tkd-font);
}

.manual-banner-icon { font-size: 22px; }
.manual-banner-text { flex: 1 1 320px; display: flex; flex-direction: column; gap: 2px; font-size: 13px; color: var(--tkd-text); }
.manual-banner-text b { font-size: 14px; color: var(--adm-ok); }

.save-state {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--tkd-surface);
  border: 1px solid var(--tkd-border);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  color: var(--tkd-muted);
}

.save-state.is-saved { border-color: var(--adm-ok-border); color: var(--adm-ok); }
.save-state.is-error { border-color: var(--adm-danger-border); background: var(--adm-danger-bg); color: var(--adm-danger); }

.save-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid var(--tkd-border);
  border-top-color: var(--tkd-navy);
  border-radius: 50%;
  animation: save-spin 0.7s linear infinite;
}

@keyframes save-spin { to { transform: rotate(360deg); } }

@media (prefers-reduced-motion: reduce) {
  .save-spinner { animation: none; }
}

@media (max-width: 767px) {
  .bracket-toolbar-end { margin-left: 0; padding-left: 0; border-left: 0; }
}
</style>
